import { computed, onMounted, onUnmounted, ref } from 'vue';

import { ProjectSettings } from '../context';
import { cookieConsentController } from './cookie-consent';

const isPreferencesDialogOpened = ref<boolean>(false);

const useCookieConsentDialogState = () => {
  const isDelayElapsed = ref<boolean>(false);

  let delayTimer: number | null = null;

  const isDialogVisible = computed<boolean>(
    () =>
      (isDelayElapsed.value && cookieConsentController.isChoiceRequired.value) ||
      isPreferencesDialogOpened.value,
  );

  const openPreferences = (): void => {
    isPreferencesDialogOpened.value = true;
  };

  const acceptNotRequired = (): void => {
    cookieConsentController.acceptNotRequired();
    isPreferencesDialogOpened.value = false;
  };

  const rejectNotRequired = (): void => {
    cookieConsentController.rejectNotRequired();
    isPreferencesDialogOpened.value = false;
  };

  onMounted(() => {
    delayTimer = window.setTimeout(() => {
      isDelayElapsed.value = true;
    }, ProjectSettings.pwa.installBannerDelay);
  });

  onUnmounted(() => {
    if (delayTimer !== null) {
      window.clearTimeout(delayTimer);
    }
  });

  return {
    acceptNotRequired,
    isDialogVisible,
    openPreferences,
    rejectNotRequired,
  };
};

export { useCookieConsentDialogState };
